import { render, staticRenderFns } from "./deviceOldUploadFile.vue?vue&type=template&id=424bb08c&scoped=true&"
import script from "./deviceOldUploadFile.vue?vue&type=script&lang=js&"
export * from "./deviceOldUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./deviceOldUploadFile.vue?vue&type=style&index=0&id=424bb08c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424bb08c",
  null
  
)

export default component.exports